import { render, staticRenderFns } from "./AllBranchTable.vue?vue&type=template&id=ae270f04&scoped=true&"
import script from "./AllBranchTable.vue?vue&type=script&lang=js&"
export * from "./AllBranchTable.vue?vue&type=script&lang=js&"
import style0 from "./AllBranchTable.vue?vue&type=style&index=0&id=ae270f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae270f04",
  null
  
)

export default component.exports